import { useRecoilValue } from "recoil";
import GetDetailNews from "./getDetailNews";
import { DetailNewsState } from "states";
import PageDefaultLayout from "components/LayoutContainers/PageDefaultLayout/pageDefaultLayout";
import Footer from "components/Footer";
import BreadcrumbHome from "components/Navbars/HomeNavbar/breadcrumbHome";
import { useMaterialUIController } from "context";
import { setAnotherPage } from "context";
import { useEffect } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { API_URL } from "utils/constants";
import dayjs from "dayjs";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

function DetailNews() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setAnotherPage(dispatch, true);
  }, []);
  const detailNewsState = useRecoilValue(DetailNewsState);
  return (
    <PageDefaultLayout>
      <GetDetailNews />
      {detailNewsState && (
        <>
          <BreadcrumbHome />
          <Box display={"flex"} flexDirection={"column"}>
            <Box
              sx={{ maxWidth: "1000px", margin: "auto", padding: "0 1.25rem" }}
              display={"flex"}
              flexDirection={"column"}
              gap={2}
            >
              <Typography variant="h4" sx={{ marginTop: "0.75rem" }}>
                {detailNewsState?.tieude}
              </Typography>
              <Box
                display={"flex"}
                gap={1}
                flexWrap={"wrap"}
                sx={{
                  borderBottom: "1px solid #d6d6d6",
                  paddingBottom: "0.5rem",
                }}
              >
                <Typography variant="h6" color={"red"}>
                  {detailNewsState?.tacgia},
                </Typography>
                <Typography variant="h6" color={"GrayText"}>
                  <span className="mr-1">
                    <AccessTimeIcon />
                  </span>
                  {dayjs(detailNewsState?.ngaytao).isValid()
                    ? dayjs(detailNewsState?.ngaytao).format("DD/MM/YYYY")
                    : detailNewsState?.ngaytao}
                </Typography>
              </Box>
              {detailNewsState?.anhdaidien && (
                <img
                  width={1200}
                  height={1200}
                  className="w-full h-80 object-cover"
                  src={API_URL + detailNewsState?.anhdaidien}
                  alt="anhtintuc"
                />
              )}
              {detailNewsState?.noidung && (
                <div
                  dangerouslySetInnerHTML={{ __html: detailNewsState?.noidung }}
                  className="mb-4"
                />
              )}
            </Box>
          </Box>
        </>
      )}

      <Footer isNotAbsolute={false} />
    </PageDefaultLayout>
  );
}
export default DetailNews;
